/**
 * The marketplace enum, in its own module so pure logic can import it.
 *
 * `api/collection` pulls in the axios client and, through it, firebase, which a
 * jest unit test cannot load — a util that only needs the enum should not have to
 * drag the HTTP layer in with it.
 */
export enum MarketplaceStatus {
  True = "true",
  False = "false",
  Pending = "pending",
}

/** What an approval may set: `true` is written when a collection goes live. */
export type ApprovableMarketplaceStatus = Exclude<
  MarketplaceStatus,
  MarketplaceStatus.True
>;
